// extracted by mini-css-extract-plugin
export default {"head":"List_head__YFKoA","headMain":"List_headMain__RjJdT","redTable":"List_redTable__MMHMv"};